import { render, staticRenderFns } from "./DwOverallTotals.vue?vue&type=template&id=3eb6f420&"
import script from "./DwOverallTotals.vue?vue&type=script&lang=js&"
export * from "./DwOverallTotals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports